import {
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { CalendarMonth } from "@mui/icons-material";
import { isMobile } from "react-device-detect";
import { CommonDialog } from "../common/CommonDialog";
import { RescheduleContent } from "./components/RescheduleContent";
import { useAppointmentReschedule } from "./useAppointmentReschedule";

interface IProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  setRefetch?: any;
  appointment: any;
  payment?: any;
  isPaid?: boolean;
}

export default function ScheduleRescheduleDialog({
  isOpen,
  setIsOpen,
  appointment,
  setRefetch,
  payment,
  isPaid,
}: IProps) {
  const {
    loading,
    loadingSlots,
    availableSlots,
    availableDates,
    slotsByDate,
    selectedDate,
    setSelectedDate,
    selectedSlot,
    setSelectedSlot,
    currentSlot,
    handleReschedule,
  } = useAppointmentReschedule({
    appointment,
    enabled: isOpen,
    payment,
    isPaid,
    onSuccess: () => {
      setRefetch?.((prev: boolean) => !prev);
      setIsOpen(false);
    },
  });

  function handleClose() {
    setIsOpen(false);
  }

  return (
    <CommonDialog
      handleClose={handleClose}
      isOpen={isOpen}
      mobileView={isMobile}
    >
      <DialogTitle
        fontWeight={600}
        textAlign="center"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <CalendarMonth color="primary" /> Reagendar Consulta
      </DialogTitle>
      <DialogContent>
        <RescheduleContent
          loadingSlots={loadingSlots}
          availableSlots={availableSlots}
          availableDates={availableDates}
          slotsByDate={slotsByDate}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          selectedSlot={selectedSlot}
          setSelectedSlot={setSelectedSlot}
          onCancel={() => setIsOpen(false)}
          onConfirm={handleReschedule}
          loading={loading}
          currentSlot={currentSlot}
          appointmentStatus={appointment.status}
        />
      </DialogContent>
    </CommonDialog>
  );
}
